module.exports = __webpack_public_path__ + "static/media/Resume_Yash.d0b6edb0.pdf";